import { Component, ViewChild, Renderer2, ElementRef } from '@angular/core';
import { AbstractComponent } from '../../common/component/AbstractComponent';

@Component({
  selector: 'gs-top-nav-layout',
  styleUrls: ['./TopNavLayout.scss'],
  templateUrl: './TopNavLayout.html',
})
export class TopNavLayoutComponent extends AbstractComponent {
  private _el: HTMLElement;
  public constructor(el: ElementRef, private renderer: Renderer2) {
    super();
    this._el = el.nativeElement;
  }

  public componentWillMount() {
    //
    this.renderer.addClass(document.body, 'layout-top-nav');
  }
}
